import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import * as ConfigurationActions from "../../store/configurationService/actions";
import LogoContainer from "../common/LogoContainer";
import CustomError from "./CustomError";

function SystemError() {
    const dispatch = useDispatch();
    const partnerPhone = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : "1-888-439-7443"
    );
    const showLogoOnRegistrationScreens: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.registration
            ? state.configurationState.configuration.partnerConfig.registration.includePartnerLogo
            : false
    );
    const showCustomErrorPage = useSelector(
        (state: ApplicationState) =>
            (state.configurationState &&
                state.configurationState.configuration &&
                state.configurationState.configuration.partnerConfig &&
                state.configurationState.configuration.partnerConfig.ssoOptions &&
                state.configurationState.configuration.partnerConfig.ssoOptions.showCustomErrorPage) ||
            false
    );  
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [routeLoading]);

    return (
        <div>
            {
                showCustomErrorPage ? <div className="row margin-vertical-xl">
                    <CustomError />
                    </div>:
                <div className="container">
                    <div className="row margin-vertical-xl">
                        <div className="box col-xs-12 box-has-shadow box-lg">
                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-0 col-sm-12 row flex-end">
                                    <LogoContainer internalPage={false} className="hide-mobile" showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}
                            {showLogoOnRegistrationScreens && (
                                <div className="col-xs-12 col-sm-0 hide-sm-up text-align-center">
                                    <LogoContainer internalPage={false} showLogoOnRegistrationScreens={showLogoOnRegistrationScreens} />
                                </div>
                            )}
                            <div className="box-description mav-risk-not-found null-body-detected-breach">
                                <div className="row row-container">
                                    <div className="col-sm-3"></div>
                                    <div>
                                        <div className="col-xs-12 col-sm-12 text-align-center col-main">
                                            <span className="fs-26">
                                                <RenderIcons iconName="info-circle" />
                                            </span>
                                            <div>
                                                <div className="title-main mtb-1rem">Sorry, we are unable to retrieve details at this time.</div>
                                                <div className="description">
                                                    Please call{" "}
                                                    <a className="pd-right-3" href={'tel:"' + partnerPhone + '"'}>
                                                        {partnerPhone}
                                                    </a>
                                                    if you are still experiencing issues with our site.
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default SystemError;
